{
  "toast": {
    "companyCreated": "Company created",
    "storeCreated": "Store created",
    "warehouseCreated": "Warehouse created",
    "workCalendarConfigured": "Work calendar configured",
    "departmentCreated": "Department created",
    "enterpriseSetupComplete": "Enterprise setup complete",
    "onboardingCompleted": "Onboarding completed",
    "productCreated": "Product created",
    "customerCreated": "Customer created",
    "productsSaved": "Products saved"
  },
  "errors": {
    "createOrSelectAWeekPattern": "Create or select a week pattern",
    "failedToCreateCompany": "Failed to create company",
    "failedToCreateStore": "Failed to create store",
    "failedToCreateWarehouse": "Failed to create warehouse",
    "failedToLoadWeekPatterns": "Failed to load week patterns",
    "failedToSaveCalendar": "Failed to save calendar",
    "failedToCreateDepartment": "Failed to create department",
    "unableToCompleteOnboardingPleaseReviewDetailsAnd": "Unable to complete onboarding. Please review details and retry.",
    "storeNameAndCodeAreRequired": "Store name and code are required",
    "productNameIsRequired": "Product name is required",
    "customerNameIsRequired": "Customer name is required",
    "failedToCreateProduct": "Failed to create product",
    "failedToCreateCustomer": "Failed to create customer",
    "selectAtLeastOneProductToContinue": "Select at least one product to continue",
    "couldNotSaveYourProductSelectionPleaseTry": "Could not save your product selection. Please try again."
  },
  "pages": {
    "enterpriseSetup": "Enterprise setup",
    "organizationCompanyStoreWarehouseCalendarHr": "Organization → Company → Store → Warehouse → Calendar → HR → Finance → Go Live",
    "setUpPointOfSale": "Set up Point of Sale",
    "completeTheseStepsToStartSelling": "Complete these steps to start selling"
  },
  "labels": {
    "companyName": "Company name",
    "code": "Code",
    "storeName": "Store name",
    "storeCode": "Store code",
    "warehouseName": "Warehouse name",
    "warehouseCode": "Warehouse code",
    "assignWeekPattern": "Assign week pattern",
    "departmentName": "Department name",
    "departmentCode": "Department code",
    "organizationName": "Organization name",
    "organizationType": "Organization type",
    "industry": "Industry",
    "logoUrl": "Logo URL",
    "themeMode": "Theme mode",
    "productName": "Product name",
    "sku": "SKU",
    "price": "Price",
    "customerName": "Customer name",
    "phone": "Phone"
  },
  "defaults": {
    "organizationType": "Company"
  },
  "plans": {
    "FREE": {
      "title": "Free",
      "details": "Limited usage with upgrade prompts"
    },
    "STARTER": {
      "title": "Starter",
      "details": "Small team production usage"
    },
    "PROFESSIONAL": {
      "title": "Professional",
      "details": "Growing organizations and automation"
    },
    "ENTERPRISE": {
      "title": "Enterprise",
      "details": "Advanced controls and white-label options"
    },
    "CUSTOM": {
      "title": "Custom",
      "details": "Tailored limits and bespoke plan"
    }
  },
  "theme": {
    "light": "Light",
    "dark": "Dark"
  },
  "placeholders": {
    "logoUrl": "https://..."
  },
  "productSelection": {
    "continueSetup": "Continue setup",
    "description": "Pick one or more apps for your organization. You can enable more later from settings.",
    "modules": {
      "CRM": {
        "description": "Leads, deals, and customer lifecycle"
      },
      "DESK": {
        "description": "Support and ticket workflows"
      },
      "FINANCE": {
        "description": "Accounting and reporting"
      },
      "HR": {
        "description": "Employees, attendance, and payroll"
      },
      "POS": {
        "description": "Billing, invoicing, and checkout"
      },
      "PROJECTS": {
        "description": "Tasks, sprints, and delivery"
      },
      "SOCIAL": {
        "description": "Publishing and inbox management"
      }
    },
    "saving": "Saving…",
    "title": "Choose products",
    "welcome": "Welcome — choose the products you need",
    "welcomeNamed": "Welcome, {{name}} — choose the products you need"
  },
  "wizard": {
    "actions": {
      "back": "Back",
      "continue": "Continue",
      "finishOnboarding": "Finish onboarding",
      "finishing": "Finishing..."
    },
    "eyebrow": "Fattah onboarding",
    "guidedQuickTour": "Guided quick tour",
    "stepSummary": "Step {{step}} of {{totalSteps}} — organization details, plan, branding, and guided setup.",
    "title": "Set up your organization workspace",
    "tours": {
      "crm": "CRM: Create lead → move pipeline → convert deal",
      "hr": "HR: Create employee → attendance setup → payroll run",
      "pos": "POS: Create product → create customer → generate invoice"
    },
    "whiteLabelEnterpriseOnly": "White-label branding is available on Enterprise and Custom plans."
  },
  "listActions": {
    "openPosTerminal": "Open POS terminal"
  }
}
